module.exports = __webpack_public_path__ + "img/nonwood_al.4284afef.svg";